<template>
  <div class="row">

    <div class="col-12">

        <h3>
          {{ this.$config.sites[this.$config.moniker].moniker_display_name   }}
        </h3>

        <hr>

        <div>
            <h5>Update billing information</h5>
            <p>Click below to update your billing information. This will open an new window.</p>
            <a :href="'https://billing.stripe.com/p/login/eVadTDfjE8d3f4I288?prefilled_email=' + this.$config.user.email" target="_blank" class="btn btn-primary">Update payment information</a>
        </div>

    </div>
  </div>
</template>

<script>
export default {};
</script>
<style></style>
